import React from 'react';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Header from './components/header';
import Products from './components/products';
import OurServices from './components/ourservices';
import Feature from './components/Feature';
import History from './components/history';
import OurClients from './components/ourclients';
import Contact from './components/contact';
import Footer from './components/footer';

import EcosisWeb from './pages/EcosisWeb';
import EcosisAgro from './pages/EcosisAgro';
import EcosisFood from './pages/EcosisFood';
import EcosisAgenda from './pages/EcosisAgenda';
import EcosisPet from './pages/EcosisPet';
import EcosisClinicas from './pages/EcosisClinicas';

import GlobalStyle from './styles/global';
import { theme } from './styles/theme';

function Home() {
  return (
    <>
      <Products />
      <OurServices />
      <Feature />
      <History />
      <OurClients />
      <Contact />
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Router>
        <Header />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/ecosis-web" component={EcosisWeb} />
          <Route path="/ecosis-agro" component={EcosisAgro} />
          <Route path="/ecosis-food" component={EcosisFood} />
          <Route path="/ecosis-agenda" component={EcosisAgenda} />
          <Route path="/ecosis-pet" component={EcosisPet} />
          <Route path="/ecosis-clinicas" component={EcosisClinicas} />
        </Switch>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;
